export const ERROR_DUPLICATE_NOM_APPLICATION =
  'application.unique_application_id_service_nom_application_id_client'
export const ERROR_DUPLICATE_NOM_TECHNIQUE =
  'application.unique_application_nom_technique'
export const ERROR_DUPLICATE_NOM_TAG = 'tag.unique_tag_nom_tag_id_client'

export const ERROR_INVALID_NOM_TECHNIQUE = 'nomTechnique: invalidPattern'
